import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';
export const ironwoodForestMetadata = {
  id: 'ironwood-forest',
  name: 'Ironwood Forest',
  description:
    'A shaded old-growth test of placement, recovery and precision into small classic greens.',
  environmentPreset: 'morning',
  metadata: {
    location: 'Ironwood County, Michigan',
    regionType: 'mature northern forest',
    difficulty: 73,
    typicalWind: [3, 11] as const,
    greenSpeed: [9.5, 10.5] as const,
    firmness: 'medium-soft' as const,
    primaryChallenge: 'Narrow doglegs, working tree collision and precise recovery',
    signatureHoles: [4, 7, 13, 18],
    tournamentEventId: 'event-5',
    previewTheme: 'deep-forest',
    environmentPalette: {
      fairway: '#38633d',
      rough: '#183b2b',
      bunker: '#b9a67c',
      water: '#355c62',
      haze: '#718c7c',
    },
    vegetationStyle: 'dense tall ironwood, hemlock and dark pine corridors',
    terrainStyle: terrainPreset('forest-ridges', 6, 120, 1.1).id,
  },
};
const pars = [4, 4, 3, 5, 4, 3, 4, 4, 3, 5, 4, 4, 3, 5, 4, 4, 4, 4],
  yards = [
    405, 430, 185, 570, 390, 165, 315, 445, 210, 555, 410, 425, 225, 545, 380, 440, 465, 440,
  ],
  names = [
    'Timber Gate',
    'Hemlock Bend',
    'Needle',
    'Double Turn',
    'Shade',
    'Fern',
    'Position',
    'Iron Lane',
    'Cathedral',
    'Old Growth',
    'Punchbowl',
    'Dark Corner',
    'Forest Frame',
    'Narrow Road',
    'Sawgrass',
    'Sentinel',
    'Iron Stretch',
    'Heritage',
  ];
const o: Partial<HolePlan>[] = [];
o[3] = { dogleg: 'double', trees: 18, landingZones: [{ distance: 250, width: 27 }] };
o[6] = { trees: 16, landingZones: [{ distance: 225, width: 25 }] };
o[12] = { trees: 18, greenRadius: 14 };
[15, 16, 17].forEach(
  (i) => (o[i] = { trees: 20, landingZones: [{ distance: 270, width: 28 }], greenRadius: 14 }),
);
export const createIronwoodForestDocument = () =>
  authorCourse({
    ...ironwoodForestMetadata,
    plans: plans(names, pars, yards, o).map((p) => ({
      ...p,
      trees: p.trees ?? 14,
      greenRadius: p.greenRadius ?? 14,
    })),
  });
